module.exports = __webpack_public_path__ + "static/media/expert_feedback_icon.cdd233d0.svg";